// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ApplicationInfo  {
    _originalTypeClassName = "Loom.BO.ApplicationInfo";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ApplicationInfo.translate = translateService;
}
this.SemanticVersion = null;
this.Name = null;
this.ImplementationStrategyVersion = null;
this.Version = null;
this.ApplicationInfoKey = null;
this._key = this.ApplicationInfoKey = 0; 
}

static translate: TranslateService;
_key: any;
SemanticVersion:any;
Name:any;
ImplementationStrategyVersion:any;
Version:any;
private _ApplicationInfoKey:any;
get ApplicationInfoKey(): any {
    return this._ApplicationInfoKey;
  }
set ApplicationInfoKey(value: any) {
    this._ApplicationInfoKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.ApplicationInfoKey == null || $this.ApplicationInfoKey == 0;
            }


}